import { render } from "./NewProjectPage.vue?vue&type=template&id=2c805a1a&scoped=true"
import script from "./NewProjectPage.vue?vue&type=script&lang=js"
export * from "./NewProjectPage.vue?vue&type=script&lang=js"

import "./NewProjectPage.vue?vue&type=style&index=0&id=2c805a1a&scoped=true&lang=scss"

import exportComponent from "/home/forge/mooz360.co.il/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c805a1a"]])

export default __exports__